__turbopack_context__.v({
  "change_station_error_panel": "ChangeStationErrorPanel-module-scss-module__sXsedW__change_station_error_panel",
  "change_station_error_panel__header": "ChangeStationErrorPanel-module-scss-module__sXsedW__change_station_error_panel__header",
});
